.header {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  border-bottom: 1px solid var(--color-border-secondary);
}

.userProfile {
  cursor: pointer;

  :global(.ant-typography) {
    transition: color 0.2s ease-in-out;
  }

  &:hover :global(.ant-typography) {
    color: var(--color-primary) !important;
  }
}
